// app/providers/TranslationProvider.tsx
import i18n from "app/config/i18n";
import { useTranslationResolver } from "app/hooks/useTranslationResolver";
import { ReactNode, createContext, useContext, useEffect, useState } from "react";

interface TranslationProviderProps {
    language: string;
    children: ReactNode;
}

const TranslationReadyContext = createContext(false);

export const useTranslationsReady = () => useContext(TranslationReadyContext);

const TranslationProvider = ({ language, children }: TranslationProviderProps) => {
    const { data, error } = useTranslationResolver([], language, true, { all: true });
    const [readyLanguage, setReadyLanguage] = useState<string | null>(null);

    useEffect(() => {
        if (!data) {
            setReadyLanguage(null);
            return;
        }

        i18n.addResourceBundle(language, "translation", data, true, true);
        i18n.changeLanguage(language);
        setReadyLanguage(language);
    }, [data, language]);

    if (error) {
        console.error("Translation loading failed", error);
        // Optional: fallback UI or silent fail
    }

    return (
        <TranslationReadyContext.Provider value={readyLanguage === language}>
            {children}
        </TranslationReadyContext.Provider>
    );
};

export default TranslationProvider;
